export default __webpack_public_path__ + "static/media/advantages_1.ef01acfc.svg";